import { Action } from '@ngrx/store';
import { RoomRequest, SetHotelRoomResultsPayload } from '@shared/models/hotel-search-payload.model';
import { BannerData, HotelRoom, HotelRoomPriceOrdering } from '@shared/models/hotel-search-response.model';

export const SELECT_HOTEL_ROOM_V2 = '[Travel Hotel Rooms] Select hotel room v2';
export const SET_HOTEL_ROOM_RESULTS = '[Travel Hotel Rooms] Set hotel room results';
export const SET_HOTEL_ROOM_RESULTS_SUCCESS = '[Travel Hotel Rooms] Set hotel room results success';
export const CLEAR_HOTEL_ROOM_RESULTS = '[Travel Hotel Rooms] Clear hotel room results';
export const SORT_HOTEL_ROOM_RESULTS = '[Travel Hotel Rooms] Sort hotel room results';
export const FILTER_HOTEL_ROOM_RESULTS = '[Travel Hotel Rooms] Filter hotel room results';
export const CHANGE_ROOM_LIMIT = '[Travel Hotel Rooms] Change room limit';
export const RESET_HOTEL_ROOM_RESULTS = '[Travel Hotel Rooms] Reset hotel room results';

export class SetHotelRoomResults implements Action {
  readonly type = SET_HOTEL_ROOM_RESULTS;
  constructor(
    public payload: {
      rooms: HotelRoom[];
      roomRequests: RoomRequest[];
      hotelId: number;
    }
  ) {}
}

export class SetHotelRoomResultsSuccess implements Action {
  readonly type = SET_HOTEL_ROOM_RESULTS_SUCCESS;
  constructor(public payload: SetHotelRoomResultsPayload) {}
}

export class SortHotelRoomResults implements Action {
  readonly type = SORT_HOTEL_ROOM_RESULTS;
  constructor(
    public payload: {
      selectedPriceOrder: HotelRoomPriceOrdering;
      hotelId: number;
    }
  ) {}
}

export class SelectHotelRoomV2 implements Action {
  readonly type = SELECT_HOTEL_ROOM_V2;
  constructor(
    public payload: {
      room: HotelRoom;
      banner: BannerData;
      isSameRoomSupplier: boolean;
      hotelId: number;
    }
  ) {}
}

export class ChangeRoomLimit implements Action {
  readonly type = CHANGE_ROOM_LIMIT;
  constructor(
    public payload: {
      roomLimit: number;
      seq: number;
      hotelId: number;
    }
  ) {}
}

export class ClearHotelRoomResults implements Action {
  readonly type = CLEAR_HOTEL_ROOM_RESULTS;
}

export class ResetHotelRoomResults implements Action {
  readonly type = RESET_HOTEL_ROOM_RESULTS;
}

export type HotelRoomActions =
  | SetHotelRoomResults
  | SetHotelRoomResultsSuccess
  | ClearHotelRoomResults
  | SelectHotelRoomV2
  | SortHotelRoomResults
  | ChangeRoomLimit
  | ResetHotelRoomResults;
